import { computed, toValue } from 'vue'
import { useClientStore } from '@/stores/ClientStore'
import { useProcedureStep } from '@/composables/modules/procedures'

export function useProcedureSections ({ procedure, procedure_execution }) {
  const { getClient } = useClientStore()
  const { step } = useProcedureStep({ procedure })

  const { client } = getClient()

  const sections = computed(() => step.value?.sections.getAvailableSections({ ...toValue(procedure_execution), client: client.value }) || [])

  return {
    sections
  }
}